import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { NestedRoute } from "../../components/shared/NestedRoute/NestedRoute";

export const Settings = () => {
  return (
    <Switch>
      <Redirect exact from="/settings/product-store" to="/product-store" />
      <Route render={() => <NestedRoute baseRoute="settings-sidebar" />} />
    </Switch>
  );
};
